// src/components/Design/ResultAlgosBar.tsx
import React from "react";
import { Button, Group, Loader, Text } from "@mantine/core";
import { modals } from "@mantine/modals";
import { useAppDispatch, useAppSelector } from "../app/hooks";
import { FaSave } from "react-icons/fa";
import HSpace from "../HSpace";
import { clearDesignThunk } from "./designThunk";
import { thunkPublishAlgoDevices } from "./designThunk";

const ResultAlgosBar: React.FC = () => {
  const dispatch = useAppDispatch();

  const algosInProgress = useAppSelector((state) => state.design.algosInProgress);
  const savingDevices = useAppSelector((state) => state.device.savingDevices);
  const nonPublischedDevicesFromAlgos = useAppSelector(
    (state) => state.design.nonPublischedDevicesFromAlgos
  );

  const numberOfProducts = nonPublischedDevicesFromAlgos.length;
  const numberOfRooms = new Set(
    nonPublischedDevicesFromAlgos.map((device) => device.roomNumber).filter(Boolean)
  ).size;
  const hasProducts = numberOfProducts > 0;
  const canShowActions = !algosInProgress && savingDevices === false;

  const handlePublish = () => {
    if (numberOfRooms <= 3) {
      dispatch(thunkPublishAlgoDevices());
      return;
    }

    modals.openConfirmModal({
      title: "Lagre kopieringer?",
      children: (
        <Text size="sm">
          Vil du lagre {numberOfProducts} komponenter i {numberOfRooms} rom? Kontroller at
          kopieringene ser riktige ut før du fortsetter.
        </Text>
      ),
      labels: { confirm: "Ja, lagre", cancel: "Avbryt" },
      confirmProps: { color: "blue" },
      onConfirm: () => dispatch(thunkPublishAlgoDevices()),
    });
  };

  return (
    <Group
      w="100%"
      px="md"
      py={8}
      justify="space-between"
      align="center"
      gap="sm"
      style={{
        backgroundColor: "var(--mantine-color-blue-6)",
        color: "var(--mantine-color-white)",
      }}
    >
      <Group gap="xs" align="center">
        {canShowActions && (
          <Group gap="xs">
            <Button
              size="md"
              variant="white"
              color="green"
              disabled={savingDevices || !hasProducts}
              onClick={handlePublish}
            >
              <FaSave />
              <HSpace />
              Publiser
            </Button>

            <Button
              size="md"
              variant="outline"
              color="white"
              onClick={() => dispatch(clearDesignThunk())}
            >
              Avbryt
            </Button>
          </Group>
        )}
        {savingDevices && <Loader size="sm" color="white" />}

        <Text size="sm" c="white">
          {savingDevices
            ? "Lagrer komponenter …"
            : hasProducts
              ? `Klar til å publisere ${numberOfProducts} komponenter i ${numberOfRooms} rom.`
              : "Ingen nye komponenter å publisere."}
        </Text>
      </Group>
    </Group>
  );
};

export default ResultAlgosBar;
